import createSagaMiddleware from 'redux-saga';
import combineSectionReducers from 'combine-section-reducers';
import {
  GlobalEventDispatcher,
  GlobalPut,
  integrateReduxDevtoolsExtension,
  NgRefreshStore,
  PS20Store,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import {
  gesamtbeitragMitRabattReducer,
  gesamtbeitragReducerForApp,
  jahresbeitragReducer,
  rabattstufeReducer,
} from '@ps20-frontend/reducers';
import cloneDeep from 'lodash/cloneDeep';
import { configureStore, Dispatch, Middleware, Tuple, UnknownAction } from '@reduxjs/toolkit';
import { IAppState } from './appState';
import { rootReducer } from './reducers/rootReducer.reducer';
import { rootSaga } from './sagas/rootSaga';
import { INITIAL_STATE } from './initialState';
import { transientStateReducer } from './reducers/transient-state.reducer';
import { versicherungsnehmerReducer } from './reducers/versicherungsnehmer.reducer';
import { risikoortReducer } from './reducers/risikoort.reducer';
import { vorbelegungenReducer } from './reducers/vorbelegungen.reducer';
import { adressvorschlagReducer } from './reducers/adressvorschlag.reducer';
import { tkvVertragsoptionenReducer } from './reducers/vertragsoptionen.reducer';
import { tkvProduktReducer } from './reducers/produkt.reducer';
import { tkvTaasInfoReducer } from './reducers/tkvTaasInfoReducer';
import { antragsnummerReducer } from './reducers/antragsnummer.reducer';

export const reducers = combineSectionReducers({
  version: (version: number = null) => version,
  transientState: transientStateReducer,
  versicherungsnehmer: versicherungsnehmerReducer,
  risikoort: risikoortReducer,
  vorbelegungen: vorbelegungenReducer,
  adressvorschlag: adressvorschlagReducer,
  vertragsoptionen: tkvVertragsoptionenReducer,
  produkt: tkvProduktReducer,
  taasInfo: tkvTaasInfoReducer,
  rabattstufe: rabattstufeReducer,
  gesamtbeitrag: gesamtbeitragReducerForApp(App.TKV),
  gesamtbeitragMitRabatt: gesamtbeitragMitRabattReducer,
  jahresbeitrag: jahresbeitragReducer,
  antragsnummer: antragsnummerReducer,
});

export function tkvStoreFactory(storeIndex: unknown): PS20Store<IAppState> {
  const ngRefreshStore = new NgRefreshStore<IAppState>(App.TKV);
  const sagaMiddleware = createSagaMiddleware();
  const initialState = cloneDeep(INITIAL_STATE);
  const store = configureStore({
    reducer: rootReducer(reducers),
    devTools: integrateReduxDevtoolsExtension(`tkv-angebot-gui-${storeIndex}`),
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(sagaMiddleware, ngRefreshStore.ngRefreshMiddleware) as unknown as Tuple<ReadonlyArray<Middleware<Record<string, never>, IAppState, Dispatch<UnknownAction>>>>,
  });

  sagaMiddleware.run(rootSaga);
  ngRefreshStore.setDelegate(store);
  return ngRefreshStore;
}

GlobalPut.getInstance().globalEventDispatcherFunction = () => {
  return (window as unknown as Record<string, unknown>)['globalEventDispatcher'] as GlobalEventDispatcher;
};
